
<div  *ngIf="isDisplaypopup" class="modal fade show" id="success" tabindex="-1" role="dialog" aria-labelledby="success" style="display: block;" aria-modal="true">
    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body pt-0 px-0 pb-0">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="bg-success pt-1 mb-3"></div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 512 512" width="48"><path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0" fill="#04c3bd"></path><path d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0" fill="#fafafa"></path></svg>
                        <h5 class="my-2">Success</h5>
                        <p>{{message}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button mat-raised-button type="button" class="btn btn-success" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>